const trackingEvents = {
  auth: {
    prefix: 'Auth - ',
    events: {
      viewed: 'Auth - [Viewed]',
      sessionExpired: 'Auth - Session [Expired]',
      sign: {
        in: {
          started: 'Auth - Sign In [Started]',
          requestedOTP: 'Auth - Sign In [OTP Requested]',
          requestOTPFailed: 'Auth - Sign In [OTP Request - Failed]',
          resendOTPStarted: 'Auth - Sign In [OTP Resend - Started]',
          resendOTPDone: 'Auth - Sign In [OTP Resend - Done]',
          resendOTPFailed: 'Auth - Sign In [OTP Resent - Failed]',
          completed: 'Auth - Sign In [Completed]',
          failed: 'Auth - Sign In [Failed]'
        },
        out: 'Auth - Sign Out',
        up: {
          started: 'Auth - Sign Up [Started]',
          requestedOTP: 'Auth - Sign Up [OTP Requested]',
          requestOTPFailed: 'Auth - Sign Up [OTP Request - Failed]',
          resendOTPStarted: 'Auth - Sign Up [OTP Resend - Started]',
          resendOTPDone: 'Auth - Sign Up [OTP Resend - Done]',
          resendOTPFailed: 'Auth - Sign Up [OTP Resent - Failed]',
          completed: 'Auth - Sign Up [Completed]',
          failed: 'Auth - Sign Up [Failed]'
        }
      },
      otp: {
        requested: 'Auth - OTP [Requested]',
        requestSucceeded: 'Auth - OTP Request [Succeeded]',
        submitted: 'Auth - OTP [Submitted]',
        verified: 'Auth - OTP [Verified]',
        verificationFailed: 'Auth - OTP Verification [Failed]',
        resent: 'Auth - OTP [Resent]'
      }
    }
  },
  form: {
    prefix: 'Form - ',
    events: {
      addPurpose: {
        started: 'Form - Add Purpose [Started]',
        done: 'Form - Add Purpose [Done]',
        failed: 'Form - Add Purpose [Failed]'
      },
      select: {
        opened: 'Form - Opened',
        verificationStarted: 'Form - Verification Started'
        // completed: 'Form - Completed'
      },
      basicDetailsIdentification: {
        submit: {
          started: 'Form - Basic Details Identification - Submit [Started]',
          done: 'Form - Basic Details Identification - Submit [Done]',
          failed: 'Form - Basic Details Identification - Submit [Failed]'
        },
        edit: {
          started: 'Form - Basic Details Identification - Edit [Started]',
          done: 'Form - Basic Details Identification - Edit [Done]',
          failed: 'Form - Basic Details Identification - Edit [Failed]'
        }
      }
    }
  },
  verification: {
    prefix: 'Verification - ',
    events: {
      // customFormsValidationFailed: 'Verification - Custom Form Validation Failed',
      createProfile: {
        started: 'Create Profile [Started]',
        done: 'Create Profile [Done]',
        failed: 'Create Profile [Failed]'
      },
      submit: {
        started: 'Verification Data Submit [Started]',
        done: 'Verification Data Submit [Done]',
        failed: 'Verication Data Submit [Failed]'
      },
      edit: {
        started: 'Verification Edit [Started]',
        done: 'Verification Edit [Done]',
        failed: 'Verication Edit [Failed]'
      },
      delete: {
        started: 'Verification Delete [Started]',
        done: 'Verification Delete [Done]',
        failed: 'Verication Delete [Failed]'
      },
      skip: {
        started: 'Veriication - Skip [Started]',
        done: 'Veriication - Skip [Done]',
        failed: 'Veriication - Skip [Failed]'
      },
      movingToNextPage: 'Verification - Moving To Next Page',
      expressVerification: {
        shown: 'Verification - Express Verification Option Showed',
        accepted: 'Verification - Express Verification Option Accepted',
        rejected: 'Verification - Express Verification Option Rejected'
      },
      // uploadFileWithOldVerification: 'Verification - Upload File With Old Verification',
      // fileUpload: {
      //   started: 'Verification - File Upload [Started]',
      //   done: 'Verification - File Upload [Done]',
      //   failed: 'Verification - File Upload [Failed]'
      // },
      enquireToEditNameOnTheCertificate: 'Verification - Enquire To Edit Name On The Certificate'
    }
  },
  payment: {
    prefix: 'Payment - ',
    events: {
      transaction: {
        initiationStarted: 'Payment Initiation Started',
        initiationFailed: 'Payment Initiation Failed',
        initiated: 'Payment - [Initiated]',
        started: 'Payment Started',
        pending: 'Payment Pending',
        gatewayRedirected: 'Payment - Gateway [Redirected]',
        failed: 'Payment - [Failed]',
        cancelled: 'Payment - [Cancelled]',
        retried: 'Payment - [Retried]',
        redirectionComplete: 'Payment Redirection Completed - Checking Payment Status',
        completed: 'Payment - [Completed]',
        statusAPINotResponded: 'Payment Check Status API not responded'
      },
      step: {
        viewed: 'Payment - [Viewed]'
      },
      methodViewed: 'Payment - Method [Viewed]',
      methodSelected: 'Payment - Method [Selected]'
    }
  },
  tawkTo: {
    prefix: 'TawkTo - ',
    events: {
      widgetLoad: 'TawkTo - Widget load',
      widgetStarted: 'TawkTo - Widget started',
      chatStart: 'TawkTo - Chat start',
      chatEnd: 'TawkTo - Chat end',
      chatMessage: 'TawkTo - Chat message',
      chatReplied: 'TawkTo - Chat replied by someone',
      chatJoinedBySupport: 'TawkTo - Chat joined by support',
      chatJoinedByAI: 'TawkTo - Chat joined by AI'
    }
  },
  axios: {
    prefix: '',
    events: {
      abort: (baseUrl: string) => `Abort - /${baseUrl ?? ''}`,
      error: (baseUrl: string) => `Error - /${baseUrl ?? ''}`,
      request: (baseUrl: string) => `Request - /${baseUrl ?? ''}`,
      response: (baseUrl: string) => `Response - /${baseUrl ?? ''}`
    }
  },
  misc: {
    prefix: 'Misc -',
    events: {
      watchVideo: 'Misc - Watch Video',
      faq: 'Misc - FAQ Viewed'
    }
  },
  profileVerification: {
    prefix: 'Profile Verification - ',
    events: {
      opened: 'Profile Verification - [Opened]',
      methodSelected: 'Profile Verification - Method [Selected]',
      digilockerRedirectInitiated: 'Profile Verification - DigiLocker Redirect [Initiated]',
      digilockerAuthCompleted: 'Profile Verification - DigiLocker Auth [Completed]',
      digilockerAuthFailed: 'Profile Verification - DigiLocker Auth [Failed]',
      passportScanInitiated: 'Profile Verification - Passport Scan [Initiated]',
      digilockerDataStored: 'Profile Verification - DigiLocker Data [Stored]',
      passportOcrCompleted: 'Profile Verification - Passport OCR [Completed]',
      passportOcrFailed: 'Profile Verification - Passport OCR [Failed]',
      completed: 'Profile Verification - [Completed]'
    }
  },
  basicDetails: {
    prefix: 'Basic Details Verification - ',
    events: {
      viewed: 'Basic Details Verification - [Viewed]',
      otpRequested: 'Basic Details Verification - OTP [Requested]',
      otpRequestFailed: 'Basic Details Verification - OTP Request [Failed]',
      otpSubmitted: 'Basic Details Verification - OTP [Submitted]',
      succeeded: 'Basic Details Verification - [Succeeded]',
      failed: 'Basic Details Verification - [Failed]',
      numberUpdated: 'Basic Details Verification - Number [Updated]'
    }
  },
  education: {
    prefix: 'Education - ',
    events: {
      degree: {
        panelOpened: 'Education - Document Panel [Opened]',
        detailsEntered: 'Education - Details [Added]',
        uploadInitiated: 'Education - Document Upload [Initiated]',
        uploadCompleted: 'Education - Document Upload [Completed]',
        uploadFailed: 'Education - Document Upload [Failed]'
      },
      twelveth: {
        panelOpened: 'Education - Document Panel [Opened]',
        detailsEntered: 'Education - Details [Added]',
        uploadInitiated: 'Education - Document Upload [Initiated]',
        uploadCompleted: 'Education - Document Upload [Completed]',
        uploadFailed: 'Education - Document Upload [Failed]'
      },
      tenth: {
        panelOpened: 'Education - Document Panel [Opened]',
        detailsEntered: 'Education - Details [Added]',
        uploadInitiated: 'Education - Document Upload [Initiated]',
        uploadCompleted: 'Education - Document Upload [Completed]',
        uploadFailed: 'Education - Document Upload [Failed]'
      },
      degreeAdded: 'Education - Degree [Added]',
      degreeRemoved: 'Education - Degree [Removed]',
      verificationSubmitted: 'Education - Verification [Submitted]'
    }
  },
  nameChange: {
    prefix: 'Name - ',
    events: {
      initiated: 'Name - Change [Initiated]',
      documentUploaded: 'Name - Change Document [Uploaded]',
      submitted: 'Name - Change [Submitted]'
    }
  },
  postPayment: {
    prefix: 'Post Payment - ',
    events: {
      insufficiencyDetailsViewed: 'Post Payment - Insufficiency Details [Viewed]',
      insufficiencyDocumentUploaded: 'Post Payment - Insufficiency Document [Uploaded]',
      insufficiencyResolved: 'Post Payment - Insufficiency [Resolved]',
      additionalDocumentsInitiated: 'Post Payment - Additional Documents [Initiated]',
      additionalPaymentCompleted: 'Post Payment - Additional Payment [Completed]',
      phoneNumberUpdateInitiated: 'Post Payment - Phone Number Update [Initiated]',
      phoneNumberUpdated: 'Post Payment - Phone Number [Updated]',
      wesNumberUpdateInitiated: 'Post Payment - WES Number Update [Initiated]',
      finalReportSent: 'Post Payment - Final Report [Sent]',
      verificationCompleted: 'Post Payment - Verification [Completed]'
    }
  },
  selfVerification: {
    events: {
      digilocker: {
        started: 'Self Verification - Digilocker [Started]'
      }
    }
  }
};

export { trackingEvents };
